import React, { FC, memo } from 'react'

import styled from 'styled-components'

const Container = styled.div<{ width?: number; align: CellAlignType }>`
  width: ${({ width }) => (width ? `${width}%` : '100%')};
  //widthを設定している場合はその値が有効になるようにする
  flex-shrink: ${({ width }) => (width ? '0' : '1')};
  display: flex;
  align-items: center;
  justify-content: ${({ align }) =>
    align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'stretch'};
`

type CellAlignType = 'left' | 'center' | 'right'

type DivProps = React.HTMLAttributes<HTMLDivElement>
export type CellProps = {
  /** Cell 1つのwidthを%で指定する */
  width?: number
  children?: React.ReactNode
  align?: CellAlignType
}

type Props = CellProps & DivProps

export const TableCell: FC<Props> = memo(({ width, children, align = 'left', ...divProps }) => {
  return (
    <Container width={width} align={align} {...divProps}>
      {children}
    </Container>
  )
})
